import React, { Component } from "react";
import { withApollo } from "react-apollo";
import mixpanel from 'mixpanel-browser';
import { InvoiceAccounting } from "../../store/person/accounting";
import { getClient } from "../../init-apollo-googleFn";
import get from "lodash/get";
import { Loader } from '../../components/Loader/Loader';
import { Table } from "../../components/Tables/CreditsData";
import { ACCOUNTING } from "../../utils/constants";
import "react-toastify/dist/ReactToastify.css";
import "./Accounting.scss"

const invoiceClient = getClient(ACCOUNTING);

class Credits extends Component {
  constructor(props) {
    super(props);
    this.state = {
      primary: this.props.selectedPrimary
        ? this.props.selectedPrimary.node
        : "",
      loading: false,
      invoiceCache: [],
      offset: 0,
    };
  }

  componentDidMount() {
    this.getLedger();
    mixpanel.track('Manager Page Load', {
      'sub': 'Credits'
     });
  }
  componentWillReceiveProps(prevProps) {
    const nodeData = prevProps.selectedPrimary
      ? prevProps.selectedPrimary.node
      : "";
    if (nodeData !== this.state.primary) {
      this.setState({ primary: nodeData }, () => {
        this.setState({
          selectedMonthEvents: {
            ...this.state.selectedMonthEvents,
            montEvents: [],
          },
        });
        this.getLedger();
      });
    }
  }

  getLedger = (data) => {
    try {
      if (data === undefined) {
        this.setState({ loading: true });
        invoiceClient
          .query({
            query: InvoiceAccounting,
            variables: {
              location: this.props.selectedPrimary.node.id,
              credits:true,
              offset: this.state.offset,
              limit: 1000,
            },
          })
          .then((res) => {
            if (res.data) {
              this.setState({
                invoiceCache: get(res, "data.slLocationInvoices.data", []),
                totalItems: get(res, "data.slLocationInvoices.totalItems"),
              });
              if (res.data.slLocationInvoices.data.length === 1000) {
                this.setState({
                  offset: this.state.offset + 1000
                });
              }
            }
            this.setState({ loading: false });
          })
          .catch((error) => {
            console.log(error);
            this.setState({ loading: false });
          });
      }
      else {
        invoiceClient
          .query({
            query: InvoiceAccounting,
            variables: {
              location: this.props.selectedPrimary.node.id,
              credits:true,
              offset: this.state.offset,
              limit: 1000,
            },
          })
          .then((res) => {
            if (res.data) {
              const value = [...data, ...get(res, "data.slLocationInvoices.data", [])];
              this.setState({invoiceCache: value});
              if (res.data.slLocationInvoices.data.length === 1000) {
                this.setState({
                  offset: this.state.offset + 1000
                });
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } catch (e) {
      this.setState({ loading: false });
    }
  };



  dataPush = (response) => {
    this.setState((prevState) => ({
      invoiceCache: [
        response.data.createSlInvoice.slInvoice,
        ...prevState.invoiceCache,
      ],
    }));
  };
  updateInvoice = (status, invoiceId) => {
    const { invoiceCache } = this.state;
    const array = [];
    if (status === "Delete") {
      this.setState({ invoiceCache: invoiceCache.filter(invoice => invoice._id !== invoiceId) })
    }
    else {
      invoiceCache.forEach((invoice) => {
        if (invoice._id === invoiceId) {
          invoice.status = status;
          array.push(invoice);
        } else {
          array.push(invoice);
        }
      });
      this.setState({ invoiceCache: array });
    }
  };

  render() {
    const { loading } = this.state;
    return (
      <>
       <main className="main-content" role="main">
        <div className="roll-container">
        {loading ? (
          <Loader text inTable/>
        ) : (
          <Table
            updateInvoice={this.updateInvoice}
            user={this.props.user}
            getNewData={this.getNewData}
            property={this.props.selectedPrimary && this.props.selectedPrimary.node && this.props.selectedPrimary.node.customId}
            dataPush={this.dataPush}
            getLedger={this.getLedger}
            invoiceCache={this.state.invoiceCache && this.state.invoiceCache}
            totalItems={this.state.totalItems && this.state.totalItems}
            propertyId={this.props.selectedPrimary.node && this.props.selectedPrimary.node.id}
          />
        )}
        </div>
        </main>
      </>
    );
  }
}

export default withApollo(Credits);
